import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import EventsHero from "./components/EventsHero";
import UpcomingEvents from "./components/UpcomingEvents";
import PastEvents from "./components/PastEvents";

export default function EventsPage() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <EventsHero />
      <UpcomingEvents />
      <PastEvents />
      <Footer />
    </div>
  );
}
